<template>
    <div v-if="profile && canRenew">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-badge color="error" dot overlap>
                    <v-btn :to="{ name: 'payment-resubscription' }" icon color="warning" class="mr-12 renewal-btn pulse-animation" v-on="on" v-bind="attrs">
                        <v-icon size="40">notifications_active</v-icon>
                    </v-btn>
                </v-badge>
            </template>
            <span>Vous pouvez renouveler votre adhésion</span>
        </v-tooltip>
    </div>
</template>

<style scoped>
.renewal-btn {
    transition: transform 0.3s;
}
.renewal-btn:hover {
    transform: scale(1.1);
}
.pulse-animation {
    animation: pulse 2s infinite;
}
@keyframes pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.7);
    }
    70% {
        box-shadow: 0 0 0 10px rgba(255, 193, 7, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
    }
}
</style>

<script>
export default {
    data() {
        return {
            profile: null,
        }
    },
    computed: {
        canRenew() {
            if (!this.$acl.check('isPro') || !this.profile.premium_dates) {
                return false;
            }
            const endDate = this.$moment(this.profile.premium_dates.end).format('YYYY-MM-DD');
            const showAlertDate = this.$moment(endDate).subtract(15, 'days').format('YYYY-MM-DD');
            const today = this.$moment().format('YYYY-MM-DD');
            
            return this.$moment(today).isBetween(showAlertDate, endDate);
        }
    },
    mounted() {
        this.getUser()
    },
    methods: {
        getUser() {
            this.$store.dispatch('userRequest', { id: this.$store.getters.getProfile.id })
                .then(result => {
                    this.profile = result.data
                })
                .catch((err) => {
                    if (err.response.status !== 403)
                        this.$store.dispatch('setErrors', err.response.data)
                })
        },
    }
}
</script> 